import React, {Component} from 'react';
import TableHolderCustom from './table-holder-custom';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import moment from 'moment-timezone';
import DateRangePickerFilter from './date-range2';
import Utils from "../../Utils/Utility";
import Api from "../../Utils/api";


const columns = {
    'orderType'        : {type : 'string',label : 'Order Type'},
    'orderCount'      : {type : 'string',label : 'Orders'},
    'itemsToPrep'      : {type : 'string',label : 'Items'},
    'totalAmount'      : {type : 'number',label : 'Total', prefix: '$'},
    'subTotal'         : {type : 'number',label : 'Sub-Total', prefix: '$'},
    'taxes'            : {type : 'number',label : 'Taxes', prefix: '$'},
    'tipAmount'        : {type : 'number',label : 'Tip', prefix: '$'},
    'serviceFee'       : {type : 'number',label : 'Service Fee', prefix: '$'},
    'deliveryFee'      : {type : 'number',label : 'Delivery Fee', prefix: '$'},
    'platformCharge'   : {type : 'number',label : 'Platform Charge', prefix: '$'}
}


export default class OrdersSummaryTable extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            ordersData      : [],
            isLoaded       : true,
            activeLocation : null,
            fromDate       : this.setLocationTimeZoneInMoment(),
            toDate         : this.setLocationTimeZoneInMoment(),
            timeZone       : null,
            totalOrderCount: 0,
            showOrderSummary: false
        };

        this._bind(
            'initializeDateTime',
            'fetchOrderDetails',
            'onDateSelectionChanged',
            'setLocationTimeZoneInMoment'
            // 'parseOrderData'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    /*  Set default timezone on moment  */
    setLocationTimeZoneInMoment(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);
        return moment();
    }

    initializeDateTime(){

        let self = this;

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);

        defaultFromDate.setDate(defaultFromDate.getDate() - 0);
        defaultFromDate.setHours(0, 0, 0, 0);

        defaultToDate.setHours(23, 59, 59, 0);

        this.setState({
            ordersData      : [],
            fromDate       : defaultFromDate,
            toDate         : defaultToDate,
            totalOrderCount: 0,
            showOrderSummary : true
        },()=>{

            Utils.isUserSessionInvalid().then((response) => {
                self.fetchOrderDetails();
            }, (error) => {
                // console.log("error user session: "+JSON.stringify(error));
                // user session is invalid
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

            });

        });

    }

    componentDidMount() {

        let self = this;
        self.initializeDateTime();
    }

    onDateSelectionChanged(fromDate, toDate) {

        this.setState({
            fromDate, toDate,
            isLoaded: false,
            ordersData:[],
            totalOrderCount : 0
        }, () => {
            this.fetchOrderDetails();
        });
    }

    fetchOrderDetails() {

        if (!this.state.activeLocation) {
            return;
        }

        let self = this;
        self.setState({
            isLoaded : false
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = self.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let fromDate = self.state.fromDate;
        let toDate = self.state.toDate;

        // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
        // let toDateTime =  moment(toDate).format('YYYY-MM-DD');
        let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
        let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);

        const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};

        Api.getOrdersSummary(
            userId, sessionToken, dateRange, locId, bizId
        ).then((response) => {
                // console.log(JSON.stringify(response));
                self.parseOrderData(response);
            },
            (error) => {
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
            });

    }
    // Commented bcz we can not use the master key in client side
    // We will use for future

    // ParsePFquery(bizId, locId, fromDateTime, toDateTime) {
    //
    //
    //     let self = this;
    //
    //     // Parse PF query https://docs.parseplatform.org/js/guide/#aggregate
    //
    //     var pipeline = [
    //         {
    //             match: {
    //                 bizId: bizId,
    //                 locationDetailPointer: locId,
    //                 charged: true,
    //                 createdAt: {$gte: fromDateTime, $lte: toDateTime}
    //             }
    //         },
    //         {
    //             group: {
    //                 objectId: '$orderType',
    //                 orderCount: {$sum: 1},
    //                 itemsToPrep: {$sum: '$itemsToPrep'},
    //                 totalAmount: {$sum: '$totalAmount'},
    //                 subTotal: {$sum: '$subTotal'},
    //                 serviceFee: {$sum: '$serviceFee'},
    //                 deliveryFee: {$sum: '$deliveryFee'},
    //                 tipAmount: {$sum: '$tipAmount'},
    //                 taxes: {$sum: '$taxes'},
    //                 platformCharge: {$sum: '$platformCharge'}
    //             }
    //         }
    //     ];
    //
    //
    //     var query = new Parse.Query("Order");
    //
    //     query.aggregate(pipeline)
    //         .then(function (results) {
    //
    //             // console.log(JSON.stringify(results));
    //             self.parseOrderData(results);
    //
    //
    //         })
    //         .catch(function (error) {
    //             // There was an error.
    //             console.log(JSON.stringify(error))
    //             Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
    //
    //
    //         });
    // }

    parseOrderData(orderResponseData){

        let self = this;
        if (orderResponseData.data && orderResponseData.data.length > 0) {
            const results = orderResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};
                Object.keys(columns).forEach(col => {

                    if (col === "totalAmount") {
                        newTable[col] = Utils.number2digit(result["totalAmount"]);
                    }
                    else if (col === "subTotal") {
                        newTable[col] = Utils.number2digit(result["subTotal"]);
                    }
                    else if (col === "platformCharge") {
                        newTable[col] = Utils.number2digit(result["platformCharge"]);
                    }
                    else if (col === "taxes") {
                        newTable[col] = Utils.number2digit(result["taxes"]);
                    } else if (col === "tipAmount") {
                        newTable[col] = Utils.number2digit(result["tipAmount"]);
                    }else if (col === "serviceFee") {
                        newTable[col] = Utils.number2digit(result["serviceFee"]);
                    }else if (col === "deliveryFee") {
                        newTable[col] = Utils.number2digit(result["deliveryFee"]);
                    }else if (col === "orderType") {
                        // newTable[col] = result["orderType"];
                        newTable[col] = result["objectId"];
                    }
                    else {
                        newTable[col] = result[col];
                    }
                });

                self.state.ordersData.push(newTable);

            });

            self.calculateOrderTotal(results.length, results)

        }
        else {
            self.setState({
                isLoaded: true
            });
        }

    }

    calculateOrderTotal(orderTotal, TotalOrderResults) {

            // get the orderReportData
            // var ordersData = this.state.ordersData;
            var ordersData = TotalOrderResults;

            // add all the key which we want to calculate the sum
            let keyOrderSummary = ['itemsToPrep', 'totalAmount', 'subTotal', 'taxes', 'tipAmount', 'serviceFee', 'deliveryFee','orderCount','platformCharge'];

            let TotalRowData = {};
            TotalRowData['orderType'] = "All";

            keyOrderSummary.forEach(keyName => {
                var keyNameSum = 0;
                if (keyName === "itemsToPrep" || keyName === "orderCount") {
                    keyNameSum = Utils.sumProperty(ordersData, keyName);
                } else {
                    keyNameSum = Utils.number2digit(Utils.sumProperty(ordersData, keyName));
                }

                TotalRowData[keyName] = keyNameSum;
            });

            // push total count data
            this.state.ordersData.push(TotalRowData);


        this.setState({
            isLoaded: true,
            totalOrderCount: orderTotal
        });

    }

    componentWillMount() {

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);

        let self = this;
        self.setState({
            activeLocation: this.props.activeLocation,
            timeZone: timeZone
        });
    }

    componentWillReceiveProps(nextProps) {
        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if (currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if (nextProps !== null
            &&
            nextProps.activeLocation !== null
            &&
            nextProps.activeLocation.objectId !== locId
        ) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    timeZone: Utils.extractTimeZoneFromLocation(nextProps.activeLocation),
                    ordersData: [],
                    totalOrderCount: 0,
                },
                () => {
                    this.initializeDateTime();
                });
        }
    }


    render() {

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                {
                    this.state.showOrderSummary ? (
                        <div>

                            <div className = "col-md-12 order-container-pg">
                                {/*<div className="col-md-12">*/}

                                {/*</div>*/}
                                <div className="row">
                                    <div className={"col-md-12 no-gutter ml-10 summary-container"}>
                                        <DateRangePickerFilter
                                            className={"datepicker-container"}
                                            fromMessage={"Select date range"}
                                            defaultDateRangeDays={"730"}
                                            startDefaultFromDays={"0"}
                                            allowMinPastYear={"3"}
                                            timeZone = {this.state.timeZone}
                                            callBackParent={this.onDateSelectionChanged}/>

                                        <div className="col-md-3">

                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="">
                                <div className="col-md-12 text-center">
                                    <h3 className="h-small-new"><b>Order summary
                                        from {Utils.getDateString(this.state.fromDate, this.state.timeZone)} to {Utils.getDateString(this.state.toDate, this.state.timeZone)}
                                    </b>
                                    </h3>
                                </div>
                            </div>

                            <div className="col-md-12">
                                {
                                    this.state.totalOrderCount > 0 ?
                                        <TableHolderCustom
                                            columns={columns}
                                            tableData={this.state.ordersData}
                                            isPrevBtnActive={'disabled'}
                                            isNextBtnActive={'disabled'}
                                            countDefault={0}
                                            // pagination={this.state.pagination}
                                        /> :
                                        <div className="col-md-12 text-center">
                                            <h4 className="h-small">No record found
                                            </h4>
                                        </div>
                                }
                            </div>

                        </div>
                    ) : null
                }

            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/visualization/orders-summary-table.js